module.exports = __webpack_public_path__ + "img/phantom.9b1a1e18.svg";